import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlarmClock } from '@fortawesome/pro-solid-svg-icons';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons';
import { HtmlContent } from 'Pages/NotificationsTooltip/NotificationsTooltip';

import { TNotifications } from 'types';
import { NotificationStatusEnum } from 'enums';

import './NotificationsTooltip.scss';

type AssistantAlertProps = {
  handleRemindLater: (id: string) => void;
  handleCancelRemindLater: (id: string) => void;
  markAsReadSingleNote: (notification: TNotifications) => void;
  notification: TNotifications;
};
const AssistantAlertContent = ({
  handleRemindLater,
  handleCancelRemindLater,
  markAsReadSingleNote,
  notification,
}: AssistantAlertProps) => {
  const history = useHistory();
  const handlePromoteListingClick = (
    notification: TNotifications,
    event?: React.MouseEvent<Element, MouseEvent>
  ) => {
    if (notification.read === 0) {
      markAsReadSingleNote(notification);
    }
    history.push(notification.route);
  };
  const handleReminderClick = (
    notification: TNotifications,
    event?: React.MouseEvent<Element, MouseEvent>
  ) => {
    if (notification.read === 0) {
      markAsReadSingleNote(notification);
    }
    handleRemindLater(notification.id);
  };
  const handleCancelReminderClick = (
    notification: TNotifications,
    event?: React.MouseEvent<Element, MouseEvent>
  ) => {
    if (notification.read === 0) {
      markAsReadSingleNote(notification);
    }
    handleCancelRemindLater(notification.id);
  };
  return (
    <FlexBox flexDirection="column" gap="8px">
      <FlexBox gap="12px" UNSAFE_className="notification-img-container" flexDirection="column">
        <FlexBox gap="12px">
          {notification.image_url && (
            <img src={notification.image_url} width={128} height={108} alt="assistant alert" />
          )}
          {HtmlContent(notification.message)}
        </FlexBox>
        {notification.severity_level === NotificationStatusEnum.CONTACTS &&
          notification.contact_data && (
            <FlexBox flexDirection="column" gap="8px">
              {notification.contact_data.map(contact => (
                <a
                  href={`/my-contacts/${contact.id}/contact-details`}
                  key={contact.id}
                  className="contact-alert"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    if (notification.read === 0) {
                      markAsReadSingleNote(notification);
                    }
                  }}
                >
                  <span>{contact.name}</span>
                  <FontAwesomeIcon icon={faExternalLink} color="#FFAB03" fontSize="24px" />
                </a>
              ))}
            </FlexBox>
          )}
      </FlexBox>
      {notification.severity_level ===
      NotificationStatusEnum.CONTACTS ? null : notification.severity_level ===
        NotificationStatusEnum.SUBMITTED ? (
        <Button
          kind="link"
          weight="bold"
          UNSAFE_className="remind-btn"
          onClick={event => handlePromoteListingClick(notification, event)}
        >
          View the Campaign
        </Button>
      ) : (
        <FlexBox alignItems="center" gap="8px">
          <Button
            kind="default"
            size="l"
            onClick={() => handlePromoteListingClick(notification)}
            UNSAFE_className="promote__btn"
          >
            Promote{' '}
            {notification.title.includes('Sold') || notification.title.includes('Likely Sellers')
              ? 'Success'
              : 'Listing'}
          </Button>
          {!notification.remind_at &&
            notification.severity_level !== NotificationStatusEnum.REMINDER && (
              <Button
                kind="link"
                weight="bold"
                UNSAFE_className="remind-btn"
                onClick={event => handleReminderClick(notification, event)}
              >
                Remind me Tomorrow
              </Button>
            )}
          {notification.remind_at && (
            <FlexBox alignItems="center" UNSAFE_className="reminder" gap="4px">
              <FontAwesomeIcon icon={faAlarmClock} color="#B0B0B0" style={{ fontSize: '16px' }} />
              Reminder set for tomorrow
              <Button
                kind="link"
                UNSAFE_className="remind-btn"
                onClick={event => handleCancelReminderClick(notification, event)}
              >
                Cancel
              </Button>
            </FlexBox>
          )}
        </FlexBox>
      )}
    </FlexBox>
  );
};

export default AssistantAlertContent;
